var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"bi_main"},[_c('iframe',{ref:"BIiframe",staticClass:"statistics_iframe",attrs:{"name":"BI","id":"BIiframe","allowFullScreen":"true","src":_vm.BiBaseUrl,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }